import { type PlainRunner } from "@/queries/runner-queries";
import { type FC } from "react";
import { RunnerPhaseTag } from "@/components/runners/RunnerPhaseTag";
import { LinuxRunnerAdditionalFieldsKeys } from "@/components/runners/details/runner-configuration-keys";
import { DegradationReason, Info } from "@/components/runners/details/CloudFormationStackDetails";

export const LinuxRunnerDetails: FC<{ runner: PlainRunner }> = ({ runner }) => {
    const dict = Object.fromEntries(runner.status?.additionalInfo.map((info) => [info.key, info.value]) || []);

    const os = dict[LinuxRunnerAdditionalFieldsKeys.OS] || "";
    const rootDiskSize = dict[LinuxRunnerAdditionalFieldsKeys.RootDiskSize] || "";
    const homeDiskSize = dict[LinuxRunnerAdditionalFieldsKeys.HomeDiskSize] || "";
    const kernel = dict[LinuxRunnerAdditionalFieldsKeys.Kernel] || "";
    const cores = dict[LinuxRunnerAdditionalFieldsKeys.Cores] || "";
    const memory = dict[LinuxRunnerAdditionalFieldsKeys.Memory] || "";
    const hostname = dict[LinuxRunnerAdditionalFieldsKeys.Hostname] || "";

    return (
        <div className="flex flex-col gap-2 overflow-x-hidden rounded-lg bg-surface-primary p-4">
            <Info label="Status">
                <RunnerPhaseTag runner={runner} />
            </Info>
            <DegradationReason runner={runner} />
            <Info label="Runner name">{runner.name}</Info>
            <Info label="Runner version">{runner.status?.version}</Info>
            {runner.status?.gatewayInfo?.gateway && (
                <Info label="Proxy domain">{runner.status.gatewayInfo.gateway.url}</Info>
            )}
            {os && <Info label="OS">{os}</Info>}
            {rootDiskSize && <Info label="Root disk size">{rootDiskSize}</Info>}
            {homeDiskSize && <Info label="Home disk size">{homeDiskSize}</Info>}
            {kernel && <Info label="Kernel">{kernel}</Info>}
            {cores && <Info label="Cores">{cores}</Info>}
            {memory && <Info label="Memory">{memory}</Info>}
            {hostname && <Info label="Hostname">{hostname}</Info>}
        </div>
    );
};
